import { render, staticRenderFns } from "./orders-new.vue?vue&type=template&id=758f4102&scoped=true&"
import script from "./orders-new.vue?vue&type=script&lang=ts&"
export * from "./orders-new.vue?vue&type=script&lang=ts&"
import style0 from "./orders-new.vue?vue&type=style&index=0&id=758f4102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758f4102",
  null
  
)

export default component.exports